let dt_index = null;
let microsite_id = null;
let error404_id = null;

export function index(params){

    dt_index = $('#errors404_table').DataTable({
        ajax: {
            url: $('#errors404_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '65', data: null, orderable: false, searchable: false, class: 'actions', render: render_errors404_actions },
            { data: 'url', orderable: true, searchable: true },
            { data: 'referer', orderable: true, searchable: true },
            { data: 'hits', orderable: true, searchable: true },
            { data: 'created_at', orderable: true, searchable: true, render: datatables.render_datetime },
            { data: 'updated_at', orderable: true, searchable: true, render: datatables.render_datetime },
        ],
        order: [[2, 'asc']],
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_errors404"]').click(batch_delete_errors404);
    });

    // dt_index.on('draw', function(e, settings){
    //     $(settings.nTableWrapper).find('.update_active').click(update_active);
    // });

    microsite_id = params.microsite_id;
}

function render_errors404_actions(data, type, row){

    const url_info = ($("#errors404_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('+ redirección') + '</a>' +
        '</div>';

    return actions;

}

export function index_reload(){
    
    dt_index.ajax.reload();

}

export function index_force_reload(){

    dt_index.column(0).checkboxes.deselectAll();
    dt_index.ajax.reload();
}

function batch_delete_errors404(params){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.errors404.batch_delete'].replace('{microsite}', microsite_id);
    
    let errors404_id = [];
    $.each(rows_selected, function(index, rowId){
        errors404_id.push(rowId);
    });
    
    if(errors404_id.length == 0){

        window.messages.error(__('No has seleccionado ningun error 404'));

    } else {

        const title = __('Eliminar errores 404');
        const text = 
            trans_choice('{1} Estás a punto de eliminar un error 404.|[2,*] Estás a punto de eliminar :count errores 404.', errors404_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    formData.append('microsite_id', microsite_id);
                    for(let error404_id of errors404_id){
                        formData.append('errors404_id[]', error404_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );

    }

}